/**
* author: duxin
* date: 2020/4/7
* describe: 首页轮播图
*/

<template>
	<ElCarousel
		:autoplay="false"
		@change="onChange"
		:interval="7000"
		indicator-position="none"
		arrow="never"
	>
		<ElCarouselItem>
			<div class="image-wrap" :class="lang == 'en' ? 'image-wrap-en' : 'image-wrap-zh'">
				<!-- <div class="image-nav image-1"></div> -->
				<!-- <div style="position: relative;">
					<div class="cont-wrap">
						<h2>{{$t("home.content1")}}</h2>
						<h2>{{$t("home.content11")}}</h2>
					</div>
				</div> -->
				<p class="text-1">
					<!-- <transition>
						<h2>{{$t("home.content1")}}</h2>
					</transition>
					<br />
					<transition>
						<h2>{{$t("home.content11")}}</h2>
					</transition>
					<br /> -->
					<!-- <transition name="title-small">
						<span class="span-1" v-show="currentIndex===0">{{$t("home.content1")}}</span>
					</transition>
					<br/> -->
					<transition name="title-small">
						<span class="span-1" v-show="currentIndex===0">{{$t("home.content11")}}</span>
					</transition>
					<br/>
					<transition name="title-large">
						<span v-show="currentIndex===0">{{$t("home.banner2")}}</span>
					</transition>
				</p>
			</div>
		</ElCarouselItem>
		<!--<ElCarouselItem>-->
		<!--<div class="image-wrap" @click="onNewBook">-->
		<!--<img class="image-nav"-->
		<!--src="../../../assets/book_20200409171519(1).jpg">-->
		<!--<p class="text-1">-->
		<!--<br/>-->
		<!--<transition name="title-large-new">-->
		<!--<span v-show="currentIndex===1">{{$t("menu.book")}}</span>-->
		<!--</transition>-->
		<!--</p>-->
		<!--</div>-->
		<!--</ElCarouselItem>-->
		<!-- <ElCarouselItem v-if="lastImg">

            <div class="image-wrap" @click="onNews">
                <img class="image-nav"
                     :src="lastImg">
                <p class="text-1 news-text">
                    <br/>
                    <transition name="title-large-new">
                        <span class="title-last" v-show="currentIndex===1&&lastTitle && lastTitle.length">{{lastTitle}}</span>
                    </transition>
                </p>
            </div>
		</ElCarouselItem>-->
	</ElCarousel>
</template>

<script>
import { GetPublicView } from '../../../api/web'

export default {
	name: 'banner-chunk',
	data() {
		return {
			currentIndex: -1,
			lastImg: '',
			lastTitle: '',
		}
	},
	mounted() {
		this.currentIndex = 0
		// this.init()
	},
	computed: {
		lang() {
			return sessionStorage.getItem('language')
		},
	},
	methods: {
		init() {
			GetPublicView({ companyId: 2 }).then((res) => {
				if (res.status && res.data) {
					this.lastImg = res.data.imageUrl
					this.lastTitle = res.data.newsTitle
					this.newsId =
						sessionStorage.getItem('language') === 'en'
							? res.data.enNewsId
							: res.data.newsId
				}
			})
		},
		onNewBook() {
			this.$router.push('/info/book')
		},
		onNews() {
			if (this.newsId)
				this.$router.push({
					name: 'WEB',
					query: { newsId: this.newsId },
				})
		},
		onChange(value) {
			this.currentIndex = value
		},
	},
}
</script>

<style lang="less" scoped>
@import '../../../style/constant.less';

.image-wrap {
	position: relative;
		background: url('../../../assets/home_banner1.jpg') no-repeat center;
		background-size: cover;
	cursor: pointer;
	height: 100%;

	.cont-wrap {
		position: absolute;
    top: 235px;
    left: 40%;
    text-align: center;
		h2 {
			font-weight: 350;
			// color: #5f6464;
			font-size: 32px;
			color: rgba(0, 0, 0, 0.6);
			text-shadow: -2px 2px 3px #aaa;
		}
	}

	.text-1 {
		position: absolute;
		z-index: 10;
		left: 0;
		right: 0;
		top: 35%;
		color: #3e3e3e;
		font-size: 60px;
		text-align: center;
		letter-spacing: 5px;
		span {
			font-weight: 350;
			color: rgba(0, 0, 0, 0.6);
			font-size: 60px;
			letter-spacing: 5px;
			text-align: center;
			text-shadow: -2px 2px 3px #aaa;
		}
		.span-1 {
			font-size: 30px;
		}
	}
	@media screen and (min-width: 320px) and (max-width: 480px) {
		.text-1 {
			span {
				display: block;
				width: 54%;
				margin: auto;
				line-height: 50px;
				font-size: 38px;
			}
			.span-1 {
				font-size: 18px;
			}
		}
	}
}
@media screen and (min-width: 320px) and (max-width: 480px) {
	.image-wrap-en {
		.text-1 {
			span {
				width: 100%;
				line-height: 40px;
			}
		}
	}
}

.title-last {
	font-size: 32px;
	background-color: rgba(255, 255, 255, 0.51);
	min-height: 60px;
	padding: 30px;
	max-width: 60%;
	text-align: center;
}

/deep/ .el-carousel__container {
	height: 70vh;
}

@media screen and (min-width: 320px) and (max-width: 480px) {
	/deep/ .el-carousel__container {
		height: 40vh;
	}

	.title-last {
		font-size: 24px !important;
		max-width: 80%;
	}
}

.title-small-enter {
	transform: translateY(20px);
	opacity: 0;
}

.title-small-enter-active {
	transition: all 0.5s 0.4s;
}

.title-large-enter {
	transform: translateY(30px);
	opacity: 0;
}

.title-large-enter-active {
	transition: all 0.5s 0.8s;
}

.title-large-new-enter {
	transform: translateY(30px);
	opacity: 0;
}

.title-large-new-enter-active {
	transition: all 0.5s 0.5s;
}
</style>
